import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import {
  trackObjectFullScreenEnter,
  trackObjectPhotoInFullScreenSlide,
  trackObjectPhotoSlide,
} from '../../../tracking';
import { Fotorama, IFotoramaProps } from '../../Fotorama';

interface IObjectFotoramaState {
  isFullScreen: boolean;
}

export class ObjectFotorama extends React.Component<IFotoramaProps, IObjectFotoramaState> {
  public state = { isFullScreen: false };

  private handleSlide = () => {
    if (this.state.isFullScreen) {
      trackObjectPhotoInFullScreenSlide();
    } else {
      trackObjectPhotoSlide();
    }
  };

  private handleFullScreenToggle = (opened: boolean) => {
    if (opened) {
      trackObjectFullScreenEnter();
    }
    this.setState({ isFullScreen: opened });
  };

  public render() {
    return (
      <div {...mergeStyles('object-fotorama', styles['fotorama'])}>
        <Fotorama
          {...this.props}
          fotoramaProps={{
            'data-width': '100%',
            'data-height': '442',
            'data-fit': 'contain',
            'data-minheight': '320',
          }}
          onFullScreenToggle={this.handleFullScreenToggle}
          onSlide={this.handleSlide}
          fullfit="contain"
        />
      </div>
    );
  }
}
